import CONTENT from 'jss-components/t01-navigation/Footer/subcomponents/ContactUsBar/ContactUsBar.content';

export const triggerLivePersonWindow = () => {
	if (!window.lpTag) {
		console.warn('-------------------------------');
		console.warn(CONTENT.LP_TAG.DOESNT_EXIST);
		console.warn('-------------------------------');
	} else {
		try {
			const engagementId = window.lpTag.events?.hasFired(
				'LP_OFFERS',
				'OFFER_IMPRESSION',
				'OFFER_DISPLAY',
			)[0]?.data?.engagementId;
			window.lpTag.taglets.rendererStub.click(engagementId);
		} catch (error) {
			console.warn('-------------------------------');
			console.warn(CONTENT.LP_TAG.ERROR);
			console.warn('-------------------------------');
			console.warn(error);
			console.warn('-------------------------------');
		}
	}
};
